import {
    Backdrop,
    Box,
    Button,
    Fade,
    Modal,
    Stack,
    SxProps,
    Typography
} from '@mui/material';
import { graphql, useStaticQuery } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React, { useEffect, useState } from 'react';
import { BlockRenderer, BlockRendererContent } from '../strapi/blockRenderer';

const backgroundImageStyles: SxProps = {
    top: 0,
    bottom: 0,
    position: 'absolute',
    left: 0,
    right: 0,
    marginInline: 'auto',
    width: 'fit-content',
    opacity: '0.13'
}

export const FirstLoadPopup = () => {
    const popupDataQuery: Queries.EntryPopupComponentQuery = useStaticQuery(graphql`
    query EntryPopupComponent {
      strapiWebsiteInfo {
        EntryPopupTitle
        EntryPopupContent {
            type
            children {
                text
                type
            }
        }
      }
    }
  `)

    const [open, setOpen] = useState(false)

    useEffect(() => {
        // runs only on the client
        const lastDismissed = localStorage.getItem('overlayDismissedAt')
        const oneDayMs = 24 * 60 * 60 * 1000
        const now = Date.now()

        const isDismissedToday =
            lastDismissed && now - Number(lastDismissed) < oneDayMs

        if (!isDismissedToday) {
            // give the page a moment to paint, then show
            requestAnimationFrame(() => setOpen(true))
        }
    }, [])

    const handleClose = () => {
        localStorage.setItem('overlayDismissedAt', Date.now().toString())
        setOpen(false)
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            closeAfterTransition
            disableAutoFocus
            disableEnforceFocus
            disableRestoreFocus
            sx={{ zIndex: '999999999999' }}
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    sx: { backgroundColor: 'rgba(0, 0, 0, 0.6)', border: 'none' },
                },
            }}
        >
            <Fade in={open} timeout={400}>
                <Box
                    sx={{
                        position: 'absolute' as const,
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: '90%', sm: 'initial' },
                        maxWidth: '600px',
                        bgcolor: '#5C1908',
                        color: '#FFF',
                        borderRadius: 1.5,
                        px: 4,
                        py: 8,
                        boxShadow: 24,
                        textAlign: 'center',
                    }}
                >
                    <Box sx={backgroundImageStyles}><Stack alignItems={'center'} justifyContent={"center"}><Box><StaticImage width={400} quality={20} layout={'constrained'} alt="person" src="../../images/icon.png" /></Box></Stack></Box>
                    {/* <Button
                        onClick={handleClose}
                        size="small"
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            color: '#FFF',
                        }}
                    >
                        CLOSE
                    </Button> */}

                    <Stack gap={3}>
                        <Stack gap={5}>
                            <Typography variant="h6" sx={{ fontStyle: 'italic' }}>
                                {popupDataQuery.strapiWebsiteInfo?.EntryPopupTitle}
                            </Typography>

                            <Typography variant="body2" component={"div"}>
                                <BlockRenderer content={popupDataQuery.strapiWebsiteInfo?.EntryPopupContent as unknown as BlockRendererContent} />
                            </Typography>
                        </Stack>

                        <Button
                            onClick={handleClose}
                            size="large"
                            color='inherit'
                            variant='outlined'
                            sx={{
                                color: '#FFF',
                                borderColor: 'white',
                                mt: 3
                            }}
                        >
                            CLOSE
                        </Button>
                    </Stack>
                </Box>
            </Fade>
        </Modal>
    )
}